import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import { Datepicker } from "flowbite-react";
import { UserAvatar } from "../../../components/user_avatar";
import { Note } from "../../../components/note-editor";
import { DELETENOTE_REQ, EDITNOTE_REQ, GETNOTES_REQ } from "../../../actions";
import moment from "moment";
import DropDown from "../../../components/dropdown";
import {
  DELETENOTE_RESPONSE,
  EDITNOTE_RESPONSE,
  SAVENOTE_RESPONSE,
} from "../../../constants/action_types";
import { Modal } from "flowbite-react";
import ContentDisplay from "../../../components/long-content-display";
import { Popup } from "../../../components/pop-up";

export function Notes({ companyDetails }) {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [noteEdit, setNoteEdit] = useState();
  const [noteDelete, setNoteDelete] = useState();
  const [loading, setLoading] = useState(false);
  const notes = useSelector((state) => state.company.notes?.data);
  const currentPage = useSelector((state) => state.company.notes?.current_page);
  const totalPage = useSelector((state) => state.company.notes?.total_pages);
  const notesUpdate = useSelector((state) => state?.company?.update_response);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (notesUpdate.type === EDITNOTE_RESPONSE) {
      setNoteEdit();
      initialFetch();
    }
    if (
      notesUpdate.type === SAVENOTE_RESPONSE ||
      notesUpdate.type === DELETENOTE_RESPONSE
    ) {
      initialFetch();
    }
  }, [notesUpdate]);

  const initialFetch = () => {
    dispatch(
      GETNOTES_REQ({
        limit: 10,
        company_uid: companyDetails?.company_uid,
        page: 1,
        // "filter.company_uid": companyDetails?.company_uid,
        // date: moment().format("YYYY-MM-DD"),
      })
    );
  };
  const fetchActivities = () => {
    if (companyDetails?.company_uid) {
      dispatch(
        GETNOTES_REQ({
          limit: 10,
          page: currentPage + 1,
          // "filter.company_uid": companyDetails?.company_uid,
          company_uid: companyDetails?.company_uid,
          // date: moment(dateFilter).format("YYYY-MM-DD"),
        })
      );
    }
  };

  // const [dateFilter, setDateFilter] = useState(new Date());

  // const handleDateChange = (date) => {
  //   // setDateFilter(date);
  //   dispatch(
  //     GETNOTES_REQ({
  //       limit: 10,
  //       company_uid,
  //       page: 1,
  //       // date: moment(date).format("YYYY-MM-DD"),
  //     })
  //   );
  // };

  useEffect(() => {
    if (companyDetails?.company_uid) initialFetch();
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [notes]);

  const pageHandling = (next) => {
    if (!loading) {
      setLoading(true);
      fetchActivities();
    }
  };

  // const redirectToCoworker = (coworker_uid) => {
  //   navigate(`/coworkers/${coworker_uid}/details`);
  // };

  return (
    <div className="h-full mt-3">
      <div className="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
        <div className="p-2">
          <div className="flow-root">
            <div className="-mx-4 -my-2 min-h-[650px] sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                <div className="mx-auto pb-5 border-b flex felx-row items-center sm:flex sm:items-center sm:justify-between">
                  <h3 className="text-lg font-semibold leading-6 text-gray-900">
                    Notes
                  </h3>
                  {/* Date picker */}
                  {/* <div id="datepicker-wrapper">
                    <Datepicker
                      onSelectedDateChanged={handleDateChange}
                      showTodayButton={false}
                      showClearButton
                      maxDate={new Date()}
                    />
                  </div> */}
                  {/* Date picker */}
                </div>
                <ol class="relative mt-5 px-2.5 dark:border-gray-700">
                  <li class="inline-flex bg-white border-2 rounded-lg p-2 [&>div>div]:border-none gap-x-4 min-w-full align-middle mb-5 shadow-md">
                    <Note
                      newNote
                      company_uid={companyDetails?.company_uid}
                      attachment_popup
                    />
                  </li>
                  {notes?.map((data) => (
                    <li class="border-2 rounded-lg min-h-[125px] w-full p-2 mb-5 shadow-md">
                      <div class="relative flex items-center space-x-3 py-2">
                        <div class="flex-shrink-0">
                          <UserAvatar user={data.created_by} />
                        </div>
                        <div class="min-w-0 flex-1">
                          <p class="text-lg font-medium text-gray-900">
                            {data.created_by.fullName || "...."}
                          </p>
                          {moment(data.updated_at).diff(data.created_at) > 0 ? (
                            <p class="text-xs text-gray-500">
                              Edited{" "}
                              {data.created_at
                                ? moment(data?.created_at).format(
                                    "DD MMM, YYYY"
                                  )
                                : "...."}
                            </p>
                          ) : (
                            <p class="text-xs text-gray-500">
                              Created{" "}
                              {data.created_at
                                ? moment(data?.created_at).format(
                                    "DD MMM, YYYY"
                                  )
                                : "...."}
                            </p>
                          )}
                        </div>
                        {(data.created_by.coworker_uid === user.coworker_uid ||
                          user.role === "ADMIN") && (
                          <div className="[&_.menu-panel]:-left-10">
                            <DropDown
                              trigger={
                                <>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="2"
                                    stroke="currentColor"
                                    class="w-6 h-6 stroke-gray-800"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                                    />
                                  </svg>
                                </>
                              }
                              items={[
                                <span
                                  onClick={() => {
                                    setNoteEdit(data);
                                  }}
                                  className="p-3 text-gray-800 cursor-pointer w-full inline-block"
                                >
                                  Edit
                                </span>,
                                <span
                                  onClick={() => {
                                    setNoteDelete(data);
                                  }}
                                  className="p-3 text-red-500 cursor-pointer w-full inline-block"
                                >
                                  Delete
                                </span>,
                              ]}
                            />
                          </div>
                        )}
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 p-2">
                        {data.note_title}
                      </h3>
                      <div id="editor-wrapper" className="relative p-2">
                        <ContentDisplay content={data.note_content} />
                      </div>
                      {data.attachments.length > 0 && (
                        <AttachmentGrid attachments={data.attachments} />
                      )}
                    </li>
                  ))}
                </ol>

                {currentPage < totalPage && (
                  <div
                    onClick={() => {
                      pageHandling();
                    }}
                    className="mt-2 p-5 hover:text-blue-600 text-indigo-500 underline text-center cursor-pointer border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                  >
                    {loading ? "loading ..." : "load more"}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal size="7xl" show={noteEdit && noteEdit.note_uid}>
        <Modal.Body
          children={
            <Note
              size="sm"
              company_uid={companyDetails?.company_uid}
              note={noteEdit}
              onEditCancel={() => setNoteEdit()}
              onEditSave={(note) => dispatch(EDITNOTE_REQ(note))}
            />
          }
        />
      </Modal>
      <Popup
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="stroke-red-600 mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to delete this note?
            </h3>
          </>
        }
        cancelText="No, cancel"
        confirmText={`Yes, proceed`}
        confirmClass="bg-red-600 text-white"
        modalState={[noteDelete, setNoteDelete]}
        onConfirm={() => {
          dispatch(DELETENOTE_REQ(noteDelete));
          setNoteDelete();
        }}
      />
    </div>
  );
}

const AttachmentGrid = ({ attachments }) => {
  const [graphicsViewCount, setGraphicsViewCount] = useState(6);
  const [docsViewCount, setDocsViewCount] = useState(6);

  const graphics = attachments.filter(
    (attachment) =>
      attachment.attachment_type.includes("image") ||
      attachment.attachment_type.includes("video")
  );
  const documents = attachments.filter(
    (attachment) =>
      !attachment.attachment_type.includes("image") &&
      !attachment.attachment_type.includes("video")
  );
  const downloadFile = (attachment) => {
    window.open(
      process.env.REACT_APP_ATTACHMENT_URL + attachment.attachment_key
    );
    // fetch(process.env.REACT_APP_ATTACHMENT_URL + attachment.attachment_key).
    // .then((response) => {
    //   if (!response.ok) {
    //     throw new Error("Network response was not ok");
    //   }
    //   return response.blob();
    // })
    // .then((blob) => {
    //   const url = window.URL.createObjectURL(blob);
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", attachment.attachment_name);
    //   document.body.appendChild(link);
    //   link.click();
    //   link.parentNode.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    // })
    // .catch((error) => {
    //   console.error("Error downloading the file:", error);
    // });
  };

  return (
    <>
      <div class="relative grid grid-cols-3 gap-4 rounded-lg p-2">
        {graphics.slice(0, graphicsViewCount).map((attachment, index) => {
          attachment.attachment_url =
            process.env.REACT_APP_ATTACHMENT_URL + attachment.attachment_key;

          return (
            <>
              <div
                onClick={() => {
                  window.open(attachment.attachment_url);
                }}
                className="relative flex justify-center items-center object-contain rounded-md cursor-pointer overflow-hidden h-40 bg-gray-100"
              >
                {attachment.attachment_type.includes("image") ? (
                  <>
                    <img
                      src={attachment.attachment_url}
                      className="h-auto w-auto"
                      alt="..."
                    />
                    <span className="absolute overflow-hidden whitespace-nowrap text-ellipsis w-full bg-gray-600/50 p-2 text-sm bottom-0 text-center text-white">
                      {attachment.attachment_name}
                    </span>
                  </>
                ) : attachment.attachment_type.includes("video") ? (
                  <video
                    src={attachment.attachment_url}
                    controls
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
                ) : (
                  <></>
                )}
                {index === graphicsViewCount - 1 &&
                  graphicsViewCount !== graphics.length && (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setGraphicsViewCount(graphics.length);
                      }}
                      className="absolute w-full h-full flex justify-center items-center text-white text-3xl font-bold bg-gray-600/75"
                    >
                      +{graphics.length - graphicsViewCount}
                    </div>
                  )}
              </div>
              {6 < graphics.length && index === graphics.length - 1 && (
                <button
                  className="text-left text-indigo-500 hover:text-indigo-700 focus:outline-none"
                  onClick={() => {
                    setGraphicsViewCount(6);
                  }}
                >
                  {"Show less"}
                </button>
              )}
            </>
          );
        })}
      </div>
      <div class="relative grid grid-cols-3 gap-4 rounded-lg p-2">
        {documents.slice(0, docsViewCount).map((attachment, index) => {
          const _split = attachment.attachment_name.split(".");
          const _ext = _split.length > 1 ? _split[_split.length - 1] : "File";
          return (
            <>
              <div
                onClick={() => {
                  downloadFile(attachment);
                }}
                className="[&:hover_.download]:flex flex h-16 text-sm cursor-pointer bg-gray-100 border-1 p-2 gap-x-2 rounded-md shadow-md items-center"
              >
                <div className="relative h-14 w-14 min-w-[3.5rem] rounded-md bg-gray-400 flex justify-center items-center">
                  <p className="text-md text-center text-white uppercase font-bold">
                    {_ext}
                  </p>
                  <div className="download hidden absolute h-full w-full bg-black/30 rounded-md flex justify-center items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="white"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                      />
                    </svg>
                  </div>
                  {/* )} */}
                </div>
                <div className="inline-block min-w-0 whitespace-nowrap text-ellipsis overflow-hidden">
                  <p className="min-w-0 whitespace-nowrap text-ellipsis overflow-hidden">
                    {attachment.attachment_name}
                  </p>
                  <p>{(attachment.attachment_size / 1024).toFixed(2)} KB</p>
                </div>
              </div>
              {index === docsViewCount - 1 &&
                docsViewCount !== documents.length && (
                  <div
                    onClick={() => {
                      setDocsViewCount(documents.length);
                    }}
                    className="absolute w-full h-full flex justify-center items-center text-white text-3xl font-bold bg-gray-600/75"
                  >
                    +{documents.length - docsViewCount}
                  </div>
                )}
              {6 < documents.length && index === documents.length - 1 && (
                <button
                  className="text-left text-indigo-500 hover:text-indigo-700 focus:outline-none"
                  onClick={() => {
                    setDocsViewCount(6);
                  }}
                >
                  {"Show less"}
                </button>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};
